<template>
  <div v-if="value" class="interviewform" :class="{ 'disabled': disabled }"  data-vv-scope="interviewForm">
    <div class="row">
      <div class="col-12">
        <checkboxinput
          v-model="value.interviewed"
          :disabled="disabled"
          :title="$t(translationKey)"
          :aria-label="$t(translationKey)"
          @input="update"
        />
      </div>
      <div
        v-if="value.interviewed"
        class="col-12 col-sm-6 col-md-4"
      >
        <forminput
          v-model="value.interviewedBy"
          :disabled="disabled"
          data-vv-as="Interview By"
          :title="$t('nonIdentProfileForm.interviewedBy')"
          :is-valid="!errors.has('interviewForm.intervName')"
          name="interviewForm.intervName"
          :required="interviewedByRequired"
          @input="update"
        />
      </div>
      <div
        v-if="value.interviewed"
        class="col-12 col-md-6 col-lg-4"
      >
        <simpledate
          v-model="value.interviewedDate"
          name="interviewForm.interDate"
          :is-valid="!errors.has('interviewForm.interDate')"
          :disabled="disabled"
          data-vv-as="Interview Date"
          @input="update"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
  import Vue from 'vue'
  import forminput from '../SPRSimpleText.vue'
  import checkboxinput from '../SPRSimpleCheckbox.vue'
  import simpledate from '../SPRSimpleDatepicker.vue'
  import { InterviewData } from '../../types/custom'

  // the data object
  export default Vue.extend({
    name: 'InterviewForm',
    components: {
      forminput,
      checkboxinput,
      simpledate
    },
    inject: ['$validator'],
    props: {
      value: {
        type: Object as () => InterviewData,
        required: true
      },
      translationKey: {
        type: String,
        default: 'nonIdentProfileForm.volunteerInterviewed'
      },
      disabled: {
        type: Boolean,
        default: false
      }
    },
    created (): void {
      if (!this.value.interviewedDate) {
        this.value.interviewedDate = new Date()
      }
    },
    computed: {
      datePlaceholder (): string {
        return this.$store.state.language === 'sv' ? 'dd.mm.åååå' : 'pp.kk.vvvv'
      },
      dateValidationRule (): string {
        return this.value.interviewed ? 'required' : ''
      },
      interviewedByValidationRule (): string {
        return this.value.interviewed ? 'required' : ''
      },
      interviewedByRequired (): boolean {
        return this.value.interviewed
      }
    },
    methods: {
      update (): void {
        if (this.value?.interviewed) {
          // run the falidator in a timeout
          setTimeout(() => {
            this.$validator.validateAll('interviewForm').then((result: boolean) => {
            if (result) {
              this.$emit('input', this.value)
            }
          })
          }, 0)
          
        } else {
          if (this.value) {
            this.value.interviewedBy = ''
            this.value.interviewedDate = undefined
            this.$emit('input', this.value)
          }
        }
      }
    },
    watch: {
      'value.interviewed'(newVal: boolean) {
        if (newVal) {
          if (!this.$validator.fields.find({ name: 'interviewForm.intervName' })) {
            this.$validator.attach({
              name: 'interviewForm.intervName',
              rules: 'required',
              getter: () => this.value.interviewedBy
            });
          }
          if (!this.$validator.fields.find({ name: 'interviewForm.interDate' })) {
            this.$validator.attach({
              name: 'interviewForm.interDate',
              rules: 'required',
              getter: () => this.value.interviewedDate
            });
          }
        } else {
          if (this.$validator.fields.find({ name: 'interviewForm.intervName' })) {
            this.$validator.detach('interviewForm.intervName');
          }
          if (this.$validator.fields.find({ name: 'interviewForm.interDate' })) {
            this.$validator.detach('interviewForm.interDate');
          }
        }
      }
    }
  })
</script>

<style lang="scss">
@import "../../assets/scss/_variables.scss";

.interviewform {
  background-color: $brand-white;

  .subheader {
    color: $brand-red;
    text-transform: uppercase;
    font-family: $font-bold;
    margin: 0 0 10px 20px;
    display: block;
    font-size: 14px;
  }

  .sectionheader {
    margin: 15px 0;
  }
}
</style>
